// libs
import { styled } from '@nykaa/ui-components';

// components
import BaseOverlaySheet from 'shared/components/OverlaySheet';

export const OverlaySheet = styled(BaseOverlaySheet)`
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: #fff;
`;

export const BuyerPhotosText = styled.div`
  ${({ theme }) => theme.typography.titleSmall};
  ${({ theme }) => `
    color:  ${theme.colors.textPrimary};
  `};
`;
